import { ActionBar } from "components/ActionBar/ActionBar";
import { FPageContent, FPageHeader } from "components/AppLayout/components/FPageLayout";
import { BackButton } from "components/FeatureButtons/BackButton";
import type { FC } from "react";

import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage } from "../../../../components/AppLayout/components/FPageLayout";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import type { NoneOwnProps } from "../../../../core/types";
import { TerminalImportLogViewForm } from "../components/forms/TerminalImportLogViewForm";

export const TerminalImportLogsViewPage: FC<NoneOwnProps> = () => {
    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.terminalImportLogViewFormPage" />
                <ActionBar>
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.TERMINAL_IMPORT_LOG}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <TerminalImportLogViewForm />
            </FPageContent>
        </FPage>
    );
};
